import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_AUTO_RECHARGE_CARD_SERVER } from '@/app/module/payments/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

/**
 * Hook to update auto recharge settings
 */
export const useUpdateAutoRecharge = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)

  const [mutate, res] = esApi.endpoints.updateOrgBalance.useMutation()

  const updateAutoRecharge = useCallback(
    async (item: { autoRecharge: boolean; autoRechargeThreshold: number; autoRechargeAmount: number }) => {
      try {
        await mutate({ orgId: orgId.toString(), body: item }).unwrap()

        dispatch(
          createNotification({
            'auto-charge-card': {
              type: 'success',
              message: `You successfully ${item.autoRecharge ? 'enabled' : 'disabled'} auto recharge.`,
            },
          }),
        )

        return true
      } catch {
        dispatch(
          createNotification({
            'auto-charge-card': {
              type: 'error',
              message: ERROR_AUTO_RECHARGE_CARD_SERVER,
            },
          }),
        )
        return false
      }
    },
    [orgId, dispatch, mutate],
  )

  return [updateAutoRecharge, res] as const
}
